const e = `.receive-address-n-card{width:300px!important;cursor:pointer;transition:all .3s ease}:deep(.card-selected){background-color:#e6f4ff!important;border-color:#1890ff!important}
`;
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/receive-address/receiveAddress.ce.vue3.js
// module id = 1281
// module chunks = 41